"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextInput = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _FormControl = _interopRequireDefault(require("../FormControl"));

var _ContentCopy = _interopRequireDefault(require("mdi-material-ui/ContentCopy"));

var _PopoverButton = require("../PopoverButton");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TextInput = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var id = props.id,
      label = props.label,
      disabled = props.disabled,
      error = props.error,
      errorMessage = props.errorMessage,
      required = props.required,
      autoFocus = props.autoFocus,
      placeholder = props.placeholder,
      type = props.type,
      helperText = props.helperText,
      multiline = props.multiline,
      rows = props.rows,
      rowsMax = props.rowsMax,
      onFocus = props.onFocus,
      onChange = props.onChange,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onClick = props.onClick,
      onBlur = props.onBlur,
      value = props.value,
      fullWidth = props.fullWidth,
      labelProps = props.labelProps,
      inputComponent = props.inputComponent,
      inputProps = props.inputProps,
      className = props.className,
      variant = props.variant,
      endAdornment = props.endAdornment,
      startAdornment = props.startAdornment,
      maxLength = props.maxLength,
      style = props.style,
      autoComplete = props.autoComplete,
      _inputRef = props.inputRef,
      copy = props.copy,
      margin = props.margin,
      readOnly = props.readOnly,
      minRows = props.minRows,
      maxRows = props.maxRows,
      InputLabelProps = props.InputLabelProps,
      InputProps = props.InputProps,
      popoverText = props.popoverText,
      customHelperIcon = props.customHelperIcon;
  var localInputRef = (0, _react.useRef)();
  var classes = (0, _styles.useStyles)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      didCopy = _useState2[0],
      setDidCopy = _useState2[1];

  var handleCopy = function handleCopy() {
    var _localInputRef$curren, _localInputRef$curren2;

    (_localInputRef$curren = localInputRef.current) === null || _localInputRef$curren === void 0 ? void 0 : _localInputRef$curren.select();
    document.execCommand("copy");
    (_localInputRef$curren2 = localInputRef.current) === null || _localInputRef$curren2 === void 0 ? void 0 : _localInputRef$curren2.blur();
    setDidCopy(true);
    setTimeout(function () {
      return setDidCopy(false);
    }, 5000);
  };

  var copyEndAdornment = /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Copied!",
    open: didCopy
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "icon",
    title: didCopy ? "" : "Copy",
    onClick: handleCopy
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.buttonTooltipFix
  }, /*#__PURE__*/_react.default.createElement(_ContentCopy.default, {
    titleAccess: "copy"
  })))));

  var appliedLabelProps = _objectSpread(_objectSpread(_objectSpread({
    className: (0, _classnames.default)("prmbl-textInput-label", classes[variant + "Label"]),
    classes: {
      shrink: classes[variant + "ShrunkLabel"],
      error: classes.error
    }
  }, labelProps), InputLabelProps), {}, {
    id: "".concat(id, "-label")
  });

  var appliedInputProps = _objectSpread(_objectSpread({}, InputProps), {}, {
    inputComponent: inputComponent,
    inputProps: _objectSpread({
      maxLength: maxLength,
      disabled: readOnly || disabled
    }, inputProps),
    inputRef: function inputRef(el) {
      localInputRef.current = el;
      if (typeof _inputRef === "function") _inputRef(el);
    },
    className: (0, _classnames.default)("prmbl-textInput-input", classes[variant + "Input"], (0, _defineProperty2.default)({}, classes.customComponent, inputComponent)),
    endAdornment: copy ? copyEndAdornment : endAdornment,
    startAdornment: startAdornment,
    classes: {
      input: classes[variant + "InputElement"]
    },
    autoComplete: autoComplete
  });

  var renderedErrorMessage = /*#__PURE__*/_react.default.createElement("strong", {
    className: classes.errorMessageWrapper
  }, /*#__PURE__*/_react.default.createElement(_Error.default, {
    className: classes.errorIcon
  }), /*#__PURE__*/_react.default.createElement("span", null, errorMessage));

  var withPopoverText = function withPopoverText(currentMessage) {
    if (!popoverText) return currentMessage;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PopoverButton.PopoverButton, {
      id: id,
      popoverText: popoverText,
      customHelperIcon: customHelperIcon
    }), currentMessage);
  };

  var readOnlyOnChange = function readOnlyOnChange() {// Do nothing
  };

  var renderedTextField = /*#__PURE__*/_react.default.createElement(_TextField.default, {
    variant: variant === "compact" ? "outlined" : variant === "inline" ? "standard" : variant,
    id: id,
    label: label,
    className: (0, _classnames.default)(className, "prmbl-textInput", classes.root, (0, _defineProperty2.default)({}, classes.error, error), classes[variant + "Wrapper"]),
    value: value !== null && value !== void 0 ? value : "",
    onChange: readOnly ? readOnlyOnChange : onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onClick: onClick,
    onBlur: onBlur,
    autoFocus: autoFocus,
    placeholder: placeholder,
    type: type,
    multiline: multiline,
    disabled: disabled,
    "aria-disabled": disabled,
    error: error,
    minRows: minRows ? minRows : rows,
    inputRef: function inputRef(input) {
      return props.inputComponent = input;
    },
    maxRows: maxRows ? maxRows : rowsMax,
    required: required,
    fullWidth: fullWidth,
    InputLabelProps: appliedLabelProps,
    InputProps: appliedInputProps,
    FormHelperTextProps: {
      classes: {
        error: classes.error,
        contained: classes.helperText
      }
    },
    helperText: error && errorMessage ? renderedErrorMessage : withPopoverText(helperText),
    style: style,
    ref: ref
  });

  return margin ? /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    id: id,
    fullWidth: fullWidth,
    error: error
  }, renderedTextField) : renderedTextField;
});

exports.TextInput = TextInput;
TextInput.displayName = "TextInput";
TextInput.defaultProps = {
  variant: "outlined",
  margin: true
};
var _default = TextInput;
exports.default = _default;